import { buildImagePdf } from "./imagePdf";
import { renderReceipt } from "./posReceiptPrint";

/**
 * The same rendering the thermal printer gets, saved as a PDF - so the
 * downloaded copy and the paper slip can never disagree.
 */

const dataUrlBytes = (dataUrl) => {
  const binary = window.atob(dataUrl.split(",")[1]);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
  return bytes;
};

export const receiptPdfBlob = async (receipt) => {
  const canvas = await renderReceipt(receipt);
  const jpeg = dataUrlBytes(canvas.toDataURL("image/jpeg", 0.92));
  const pdf = buildImagePdf(jpeg, {
    pixelWidth: canvas.width,
    pixelHeight: canvas.height,
  });
  return new Blob([pdf], { type: "application/pdf" });
};

export const downloadReceiptPdf = async (receipt, filename) => {
  const blob = await receiptPdfBlob(receipt);
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // give the browser a moment to start the download before releasing it
  setTimeout(() => URL.revokeObjectURL(url), 10000);
};
